// extracted by mini-css-extract-plugin
export default {"inlineForm":"inline-form_inlineForm__dRFZ3","actions":"inline-form_actions__q-Wuz"};